export default "__VITE_PUBLIC_ASSET__b38f4ff8__"